// Hardcoded NFL Impactful Players — source: client spreadsheet (Oct 2026)
// Keyed by team mascot name (matches team_name field in API responses)
const nflImpactfulPlayers = {
	Cardinals: {
		offense: [
			{ name: 'Jacoby Brissett', position: 'QB' },
			{ name: 'Trey McBride', position: 'TE' },
			{ name: 'Jeremiyah Love', position: 'RB' },
			{ name: 'Michael Wilson', position: 'WR' },
		],
		defense: [
			{ name: 'Budda Baker', position: 'S' },
			{ name: 'Josh Sweat', position: 'DE' },
			{ name: 'Jack Gibbens', position: 'LB' },
			{ name: 'Mack Wilson', position: 'LB' },
		],
	},
	Falcons: {
		offense: [
			{ name: 'Bijan Robinson', position: 'RB' },
			{ name: 'Michael Penix Jr.', position: 'QB' },
			{ name: 'Drake London', position: 'WR' },
			{ name: 'Kyle Pitts', position: 'TE' },
		],
		defense: [
			{ name: 'Jessie Bates III', position: 'S' },
			{ name: 'A.J. Terrell', position: 'CB' },
			{ name: 'Xavier Watts', position: 'S' },
			{ name: "Za'Darius Smith", position: 'DE' },
		],
	},
	Ravens: {
		offense: [
			{ name: 'Lamar Jackson', position: 'QB' },
			{ name: 'Derrick Henry', position: 'RB' },
			{ name: 'Zay Flowers', position: 'WR' },
			{ name: 'Mark Andrews', position: 'TE' },
		],
		defense: [
			{ name: 'Kyle Hamilton', position: 'S' },
			{ name: 'Roquan Smith', position: 'LB' },
			{ name: 'Trey Hendrickson', position: 'DE' },
			{ name: 'Nnamdi Madubuike', position: 'DT' },
		],
	},
	Bills: {
		offense: [
			{ name: 'Josh Allen', position: 'QB' },
			{ name: 'James Cook', position: 'RB' },
			{ name: 'DJ Moore', position: 'WR' },
			{ name: 'Dalton Kincaid', position: 'TE' },
		],
		defense: [
			{ name: 'Greg Rousseau', position: 'DE' },
			{ name: 'Ed Oliver', position: 'DT' },
			{ name: 'Terrel Bernard', position: 'LB' },
			{ name: 'Dorian Williams', position: 'LB' },
		],
	},
	Panthers: {
		offense: [
			{ name: 'Bryce Young', position: 'QB' },
			{ name: 'Tetairoa McMillan', position: 'WR' },
			{ name: 'Chuba Hubbard', position: 'RB' },
			{ name: 'Jalen Coker', position: 'WR' },
		],
		defense: [
			{ name: 'Derrick Brown', position: 'DT' },
			{ name: 'Jaycee Horn', position: 'CB' },
			{ name: 'Devin Lloyd', position: 'LB' },
			{ name: "Tre'Von Moehrig", position: 'S' },
		],
	},
	Bears: {
		offense: [
			{ name: 'Caleb Williams', position: 'QB' },
			{ name: "D'Andre Swift", position: 'RB' },
			{ name: 'Luther Burden III', position: 'WR' },
			{ name: 'Colston Loveland', position: 'TE' },
		],
		defense: [
			{ name: 'Montez Sweat', position: 'DE' },
			{ name: 'Kyler Gordon', position: 'CB' },
			{ name: 'Tremaine Edmunds', position: 'LB' },
			{ name: 'Jeffery Simmons', position: 'DT' },
		],
	},
	Bengals: {
		offense: [
			{ name: 'Joe Burrow', position: 'QB' },
			{ name: "Ja'Marr Chase", position: 'WR' },
			{ name: 'Chase Brown', position: 'RB' },
			{ name: 'Tee Higgins', position: 'WR' },
		],
		defense: [
			{ name: 'Dexter Lawrence', position: 'DT' },
			{ name: 'Jonathan Allen', position: 'DT' },
			{ name: 'Boye Mafe', position: 'DE' },
			{ name: 'Jordan Battle', position: 'S' },
		],
	},
	Browns: {
		offense: [
			{ name: 'Deshaun Watson', position: 'QB' },
			{ name: 'Quinshon Judkins', position: 'RB' },
			{ name: 'Denzel Boston', position: 'WR' },
			{ name: 'KC Concepcion', position: 'WR' },
		],
		defense: [
			{ name: 'Denzel Ward', position: 'CB' },
			{ name: 'Jared Verse', position: 'DE' },
			{ name: 'Carson Schwesinger', position: 'LB' },
			{ name: 'Mason Graham', position: 'DT' },
		],
	},
	Cowboys: {
		offense: [
			{ name: 'Dak Prescott', position: 'QB' },
			{ name: 'CeeDee Lamb', position: 'WR' },
			{ name: 'Javonte Williams', position: 'RB' },
			{ name: 'George Pickens', position: 'WR' },
		],
		defense: [
			{ name: 'Joey Porter Jr.', position: 'CB' },
			{ name: 'Quinnen Williams', position: 'DT' },
			{ name: 'DeMarvion Overshown', position: 'LB' },
			{ name: 'Caleb Downs', position: 'S' },
		],
	},
	Broncos: {
		offense: [
			{ name: 'Bo Nix', position: 'QB' },
			{ name: 'JK Dobbins', position: 'RB' },
			{ name: 'Jaylen Waddle', position: 'WR' },
			{ name: 'Courtland Sutton', position: 'WR' },
		],
		defense: [
			{ name: 'Patrick Surtain II', position: 'CB' },
			{ name: 'Nik Bonitto', position: 'DE' },
			{ name: 'Alex Singleton', position: 'LB' },
			{ name: 'Zach Allen', position: 'DE' },
		],
	},
	Lions: {
		offense: [
			{ name: 'Jared Goff', position: 'QB' },
			{ name: 'Jahmyr Gibbs', position: 'RB' },
			{ name: 'Amon-Ra St. Brown', position: 'WR' },
			{ name: 'Jameson Williams', position: 'WR' },
		],
		defense: [
			{ name: 'Aidan Hutchinson', position: 'DE' },
			{ name: 'Brian Branch', position: 'S' },
			{ name: 'Jack Campbell', position: 'LB' },
			{ name: 'Alim McNeill', position: 'DT' },
		],
	},
	Packers: {
		offense: [
			{ name: 'Jordan Love', position: 'QB' },
			{ name: 'Josh Jacobs', position: 'RB' },
			{ name: 'Christian Watson', position: 'WR' },
			{ name: 'Matthew Golden', position: 'WR' },
		],
		defense: [
			{ name: 'Micah Parsons', position: 'LB' },
			{ name: 'Edgerrin Cooper', position: 'LB' },
			{ name: 'Xavier McKinney', position: 'S' },
			{ name: 'Javon Bullard', position: 'S' },
		],
	},
	Texans: {
		offense: [
			{ name: 'CJ Stroud', position: 'QB' },
			{ name: 'Nico Collins', position: 'WR' },
			{ name: 'David Montgomery', position: 'RB' },
			{ name: 'Dalton Schultz', position: 'TE' },
		],
		defense: [
			{ name: 'Will Anderson Jr.', position: 'DE' },
			{ name: 'Derek Stingley Jr.', position: 'CB' },
			{ name: 'Azeez Al-Shaair', position: 'LB' },
			{ name: 'Jalen Pitre', position: 'S' },
		],
	},
	Colts: {
		offense: [
			{ name: 'Daniel Jones', position: 'QB' },
			{ name: 'Jonathan Taylor', position: 'RB' },
			{ name: 'Alec Pierce', position: 'WR' },
			{ name: 'Tyler Warren', position: 'TE' },
		],
		defense: [
			{ name: 'Sauce Gardner', position: 'CB' },
			{ name: 'Laiatu Latu', position: 'DE' },
			{ name: 'Grover Stewart', position: 'DT' },
			{ name: 'Cam Bynum', position: 'S' },
		],
	},
	Jaguars: {
		offense: [
			{ name: 'Trevor Lawrence', position: 'QB' },
			{ name: 'Parker Washington', position: 'WR' },
			{ name: 'Bhayshul Tuten', position: 'RB' },
			{ name: 'Travis Hunter', position: 'WR' },
		],
		defense: [
			{ name: 'Josh Hines-Allen', position: 'DE' },
			{ name: 'Foyesade Oluokun', position: 'LB' },
			{ name: 'Ventrell Miller', position: 'LB' },
			{ name: 'Travon Walker', position: 'DE' },
		],
	},
	Chiefs: {
		offense: [
			{ name: 'Patrick Mahomes', position: 'QB' },
			{ name: 'Kenneth Walker', position: 'RB' },
			{ name: 'Rashee Rice', position: 'WR' },
			{ name: 'Travis Kelce', position: 'TE' },
		],
		defense: [
			{ name: 'Chris Jones', position: 'DT' },
			{ name: 'Nick Bolton', position: 'LB' },
			{ name: 'George Karlaftis', position: 'DE' },
			{ name: 'Mansoor Delane', position: 'CB' },
		],
	},
	Chargers: {
		offense: [
			{ name: 'Justin Herbert', position: 'QB' },
			{ name: 'Ladd McConkey', position: 'WR' },
			{ name: 'Omarion Hampton', position: 'RB' },
			{ name: 'Quentin Johnston', position: 'WR' },
		],
		defense: [
			{ name: 'Khalil Mack', position: 'DE' },
			{ name: 'Derwin James', position: 'S' },
			{ name: 'Daiyan Henley', position: 'LB' },
			{ name: 'Tuli Tuipulotu', position: 'DE' },
		],
	},
	Rams: {
		offense: [
			{ name: 'Matthew Stafford', position: 'QB' },
			{ name: 'Puka Nacua', position: 'WR' },
			{ name: 'Kyren Williams', position: 'RB' },
			{ name: 'Davante Adams', position: 'WR' },
		],
		defense: [
			{ name: 'Myles Garrett', position: 'DE' },
			{ name: 'Aaron Donald', position: 'DT' },
			{ name: 'Trent McDuffie', position: 'CB' },
			{ name: 'Quentin Lake', position: 'S' },
		],
	},
	Raiders: {
		offense: [
			{ name: 'Kirk Cousins', position: 'QB' },
			{ name: 'Ashton Jeanty', position: 'RB' },
			{ name: 'Tre Tucker', position: 'WR' },
			{ name: 'Brock Bowers', position: 'TE' },
		],
		defense: [
			{ name: 'Maxx Crosby', position: 'DE' },
			{ name: 'Quay Walker', position: 'LB' },
			{ name: 'Nakobe Dean', position: 'LB' },
			{ name: 'Jeremy Chinn', position: 'S' },
		],
	},
	Dolphins: {
		offense: [
			{ name: 'Malik Willis', position: 'QB' },
			{ name: "De'Von Achane", position: 'RB' },
			{ name: 'Malik Washington', position: 'WR' },
			{ name: 'Ollie Gordon', position: 'RB' },
		],
		defense: [
			{ name: 'Jordyn Brooks', position: 'LB' },
			{ name: 'Jacob Rodriguez', position: 'DE' },
			{ name: 'Chop Robinson', position: 'DE' },
			{ name: 'Zach Sieler', position: 'DT' },
		],
	},
	Vikings: {
		offense: [
			{ name: 'Kyler Murray', position: 'QB' },
			{ name: 'Justin Jefferson', position: 'WR' },
			{ name: 'Aaron Jones', position: 'RB' },
			{ name: 'Jordan Addison', position: 'WR' },
		],
		defense: [
			{ name: 'Blake Cashman', position: 'LB' },
			{ name: 'Harrison Smith', position: 'S' },
			{ name: 'Andrew Van Ginkel', position: 'LB' },
			{ name: 'Dallas Turner', position: 'LB' },
		],
	},
	Patriots: {
		offense: [
			{ name: 'Drake Maye', position: 'QB' },
			{ name: 'AJ Brown', position: 'WR' },
			{ name: 'Rhamondre Stevenson', position: 'RB' },
			{ name: 'Hunter Henry', position: 'TE' },
		],
		defense: [
			{ name: 'Christian Gonzalez', position: 'CB' },
			{ name: 'Harold Landry', position: 'DE' },
			{ name: 'Robert Spillane', position: 'LB' },
			{ name: 'Milton Williams', position: 'DE' },
		],
	},
	Saints: {
		offense: [
			{ name: 'Tyler Shough', position: 'QB' },
			{ name: 'Chris Olave', position: 'WR' },
			{ name: 'Travis Etienne', position: 'RB' },
			{ name: 'Juwan Johnson', position: 'TE' },
		],
		defense: [
			{ name: 'Chase Young', position: 'DE' },
			{ name: 'Kaden Elliss', position: 'LB' },
			{ name: 'Kool-Aid McKinstry', position: 'CB' },
			{ name: 'Carl Granderson', position: 'DE' },
		],
	},
	Giants: {
		offense: [
			{ name: 'JJ McCarthy', position: 'QB' },
			{ name: 'Malik Nabers', position: 'WR' },
			{ name: 'Cam Skattebo', position: 'RB' },
			{ name: 'Isaiah Likely', position: 'TE' },
		],
		defense: [
			{ name: 'Brian Burns', position: 'DE' },
			{ name: 'Abdul Carter', position: 'LB' },
			{ name: 'Arvell Reese', position: 'DT' },
			{ name: 'Jevon Holland', position: 'S' },
		],
	},
	Jets: {
		offense: [
			{ name: 'Geno Smith', position: 'QB' },
			{ name: 'Breece Hall', position: 'RB' },
			{ name: 'Garrett Wilson', position: 'WR' },
			{ name: 'Braelon Allen', position: 'RB' },
		],
		defense: [
			{ name: 'Kingsley Enagbare', position: 'DE' },
			{ name: 'Demario Davis', position: 'LB' },
			{ name: 'Minkah Fitzpatrick', position: 'S' },
			{ name: 'David Bailey', position: 'CB' },
		],
	},
	Eagles: {
		offense: [
			{ name: 'Jalen Hurts', position: 'QB' },
			{ name: 'Saquon Barkley', position: 'RB' },
			{ name: 'DeVonta Smith', position: 'WR' },
			{ name: 'Dallas Goedert', position: 'TE' },
		],
		defense: [
			{ name: 'Jalen Carter', position: 'DT' },
			{ name: 'Zack Baun', position: 'LB' },
			{ name: 'Cooper DeJean', position: 'CB' },
			{ name: 'Jonathan Greenard', position: 'DE' },
		],
	},
	Steelers: {
		offense: [
			{ name: 'Aaron Rodgers', position: 'QB' },
			{ name: 'Jaylen Warren', position: 'RB' },
			{ name: 'DK Metcalf', position: 'WR' },
			{ name: 'Pat Freiermuth', position: 'TE' },
		],
		defense: [
			{ name: 'T.J. Watt', position: 'LB' },
			{ name: 'Cameron Heyward', position: 'DT' },
			{ name: 'Jalen Ramsey', position: 'CB' },
			{ name: 'Patrick Queen', position: 'LB' },
		],
	},
	Seahawks: {
		offense: [
			{ name: 'Sam Darnold', position: 'QB' },
			{ name: 'Jaxon Smith-Njigba', position: 'WR' },
			{ name: 'Zach Charbonnet', position: 'RB' },
			{ name: 'Cooper Kupp', position: 'WR' },
		],
		defense: [
			{ name: 'Devon Witherspoon', position: 'CB' },
			{ name: 'Leonard Williams', position: 'DE' },
			{ name: 'Ernest Jones IV', position: 'LB' },
			{ name: 'DeMarcus Lawrence', position: 'DE' },
		],
	},
	'49ers': {
		offense: [
			{ name: 'Brock Purdy', position: 'QB' },
			{ name: 'Christian McCaffrey', position: 'RB' },
			{ name: 'Mike Evans', position: 'WR' },
			{ name: 'George Kittle', position: 'TE' },
		],
		defense: [
			{ name: 'Fred Warner', position: 'LB' },
			{ name: 'Nick Bosa', position: 'DE' },
			{ name: 'DeForest Buckner', position: 'DT' },
			{ name: 'Dre Greenlaw', position: 'LB' },
		],
	},
	Buccaneers: {
		offense: [
			{ name: 'Baker Mayfield', position: 'QB' },
			{ name: 'Emeka Egbuka', position: 'WR' },
			{ name: 'Bucky Irving', position: 'RB' },
			{ name: 'Chris Godwin', position: 'WR' },
		],
		defense: [
			{ name: 'Vita Vea', position: 'DT' },
			{ name: 'Rueben Bain Jr.', position: 'DE' },
			{ name: 'Tykee Smith', position: 'S' },
			{ name: 'Josiah Trotter', position: 'LB' },
		],
	},
	Titans: {
		offense: [
			{ name: 'Cam Ward', position: 'QB' },
			{ name: 'Tony Pollard', position: 'RB' },
			{ name: 'Carnell Tate', position: 'WR' },
			{ name: "Wan'Dale Robinson", position: 'WR' },
		],
		defense: [
			{ name: 'Jermaine Johnson II', position: 'DE' },
			{ name: 'Amani Hooker', position: 'S' },
			{ name: 'Anthony Hill Jr.', position: 'LB' },
			{ name: 'John Franklin-Myers', position: 'DE' },
		],
	},
	Commanders: {
		offense: [
			{ name: 'Jayden Daniels', position: 'QB' },
			{ name: 'Terry McLaurin', position: 'WR' },
			{ name: 'Stefon Diggs', position: 'WR' },
			{ name: 'Chig Okonkwo', position: 'TE' },
		],
		defense: [
			{ name: 'Javon Kinlaw', position: 'DT' },
			{ name: 'Nick Cross', position: 'S' },
			{ name: 'Sonny Styles', position: 'LB' },
			{ name: 'Rasul Douglas', position: 'CB' },
		],
	},
};

const normalize = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');

export function getNFLImpactfulPlayers(teamName) {
	if (!teamName) return null;
	const target = normalize(teamName);
	// Exact match (handles single-word mascot names like "Chiefs")
	let key = Object.keys(nflImpactfulPlayers).find((k) => normalize(k) === target);
	if (key) return nflImpactfulPlayers[key];
	// Word fallback: API may return "Kansas City Chiefs" — match any word against a key
	const words = String(teamName).split(/\s+/).map(normalize).filter(Boolean);
	key = Object.keys(nflImpactfulPlayers).find((k) => words.includes(normalize(k)));
	return key ? nflImpactfulPlayers[key] : null;
}
